/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect, useRef } from 'react';
import { Container, FormControl, InputLabel, Checkbox, FormHelperText, Paper } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Box, Button } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import Chip from '@material-ui/core/Chip';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import TablePagination from '@material-ui/core/TablePagination';
import Page from '../../../Page';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import PropTypes from 'prop-types'
import services from '../Services';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { makeStyles } from '@material-ui/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';

var screenCode = "ANNUALFCCREPORT"

export default function AnnualPlanForFCCReport() {

    const navigate = useNavigate();
    const componentRef = useRef();
    const [headCells, SetHeadCells] = useState([]);
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(5);
    const useStyles = makeStyles((theme) => ({
        root: {
            width: '100%'
        },
        paper: {
            width: '100%',
            marginBottom: theme.spacing(2)
        },
        table: {
            minWidth: 750
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1
        }
    }));
    const classes = useStyles();
    function EnhancedTableHead(props) {
        const { order, orderBy, onRequestSort } = props;
        const createSortHandler = (property) => (event) => {
            onRequestSort(event, property);
        };
        return (
            <TableHead>
                <TableRow>
                    {headCells.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={headCell.align}
                            padding={headCell.disablePadding ? 'none' : 'normal'}
                            sortDirection={orderBy === headCell.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <span className={useStyles.visuallyHidden}>
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        )
    }

    EnhancedTableHead.propTypes = {
        classes: PropTypes.object.isRequired,
        numSelected: PropTypes.number.isRequired,
        onRequestSort: PropTypes.func.isRequired,
        onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.oneOf(['asc', 'desc']).isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired
    };

    const onKeyDown = (e) => {
        e.preventDefault();
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setLimit(parseInt(event.target.value, 10));
        setPage(0);
    };

    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [product, setProduct] = useState([]);
    const [productcatogery, setProductcatogery] = useState([]);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [reportData, setReportData] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedCategoryOptions, setSelectedCategoryOptions] = useState([]);
    const [selectedProductOptions, setSelectedProductOptions] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: '',
        productCategoryID: '',
        productID: '',
        fromDate: null,
        isActive: true,
        toDate: null,
    });

    const [totalValues, setTotalValues] = useState({
        totalCultivate: 0,
        totalDemand: 0,
        totalSupply: 0

    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const productAvailabilitySchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.array().required('Please select at least one Fresh collection center').min(1, 'Please select at least one Fresh collection center'),
        productCategoryID: Yup.array().min(1, 'Please Select Product Category').required('Product Category Required'),
        productID: Yup.array().min(1, 'Please Select Product').required('Product Required'),
        fromDate: Yup.date().min(1).min(1, 'Please Select Start Date').required('Start Date required'),
        toDate: Yup.date().min(1).min(1, 'Please Select End Date').required('End Date required')
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        operationEntityID: '',
        productCategoryID: '',
        productID: '',
        fromDate: '',
        toDate: ''
    });
    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            productCategoryID: selectedCategoryOptions,
            productID: selectedProductOptions,
            fromDate: formData.fromDate,
            toDate: formData.toDate,
            isActive: formData.isActive
        },
        validationSchema: productAvailabilitySchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm());
        },
        enableReinitialize: true,
    });

    useEffect(() => {
        getPermissions()
    }, []);

    useEffect(() => {
        setReportData([]);
    }, [formik.values.groupID, selectedOptions, selectedProductOptions, selectedCategoryOptions, fromDate, toDate]);


    useEffect(() => {
        async function fetchUserSelectedDate() {
            let dateObj = await services.GettheUserSelectedDate();
            let dateStr = dateObj && dateObj.userSelectedDate ? dateObj.userSelectedDate : null;
            if (dateStr && !dateStr.endsWith('Z')) {
                dateStr = dateStr + 'Z';
            }
            const parsedDate = dateStr ? new Date(dateStr) : null;

            let fromDateVal;
            if (parsedDate && !isNaN(parsedDate.getTime())) {
                fromDateVal = parsedDate;
            } else {
                fromDateVal = new Date();
            }

            const toDateVal = new Date(fromDateVal);
            const day = toDateVal.getDay();
            const diff = 7 - day;
            toDateVal.setDate(toDateVal.getDate() + diff);

            setFromDate(fromDateVal);
            setToDate(toDateVal);
            setFormData(prev => ({
                ...prev,
                fromDate: fromDateVal.toISOString(),
                toDate: toDateVal.toISOString()
            }));
        }
        fetchUserSelectedDate();
    }, []);

    useEffect(() => {
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [operationEntityList]);

    function getWeeklyDates(startDate, endDate = new Date()) {
        if (!startDate || isNaN(startDate.getTime())) return [];
        const result = [];
        let current = new Date(startDate);
        result.push(new Date(current));
        while (current < endDate) {
            current = new Date(current);
            current.setDate(current.getDate() + 7);
            if (current <= endDate) {
                result.push(new Date(current));
            }
        }
        return result;
    }

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWANNUALFCCREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });
        setFormData({
            ...formData,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            factoryID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        });
        trackPromise(GetAllGroups());
        trackPromise(GetProductCategoties());
    }


    async function SubmitForm() {
        SetHeadCells([]);
        setPage(0);
        setLimit(5);

        if (!fromDate || isNaN(fromDate.getTime())) {
            return;
        }

        const newRes = await services.GetAnnualPlanFCCReportDetails(
            selectedOptions.map(x => x).join(',').toString(),
            selectedProductOptions.map(x => x).join(',').toString(),
            fromDate.toISOString(),
            toDate.toISOString()
        );

        const totalCultivate = newRes.reduce((acc, curr) => acc + (curr.cultivatedQty || 0), 0);

        const totalSupply = newRes.reduce((acc, curr) => acc + (curr.netAmount || 0), 0);

        const uniqueDemandKeys = new Set();
        let totalDemand = 0;

        for (const row of newRes) {
            const key = `${row.weekStartDate}|${row.weekEndDate}|${row.skuCode}|${row.skuDescription}`;
            if (!uniqueDemandKeys.has(key)) {
                totalDemand += row.demandForecasting || 0;
                uniqueDemandKeys.add(key);
            }
        }

        setTotalValues({
            totalCultivate,
            totalDemand,
            totalSupply
        });

        setReportData(newRes);
        getSelectedDropdownValuesForReport();
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        setReportData([]);
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        setSelectedOptions([factoryValue]);
        setSelectedCategoryOptions([])
        setSelectedProductOptions([]);
    }

    useEffect(() => {
        setPage(0);
        trackPromise(GetProductCategoties());
        trackPromise(GetAllGroups());
    }, []);

    useEffect(() => {
        setPage(0);
        trackPromise(GetProductDetails());
    }, [selectedCategoryOptions]);

    useEffect(() => {
        trackPromise(GetFactoriesByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setPage(0);
        setSelectedCategoryOptions([])
        setSelectedProductOptions([])
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setPage(0);
        setSelectedProductOptions([])
    }, [formik.values.productCategoryID]);

    useEffect(() => {
        setPage(0);
    }, [formik.values.productID]);

    useEffect(() => {
        setPage(0);
    }, [fromDate]);

    useEffect(() => {
        setPage(0);
    }, [selectedOptions]);

    useEffect(() => {
        setPage(0);
        setValues({
            ...values,
            operationEntityID: selectedOptions,
            productCategoryID: selectedCategoryOptions,
            productID: selectedProductOptions
        })
    }, [selectedOptions, selectedCategoryOptions, selectedProductOptions]);

    useEffect(() => {
        setPage(0);
    }, [selectedCategoryOptions])

    useEffect(() => {
        setPage(0);
    }, [selectedProductOptions])

    useEffect(() => {
        setPage(0);
        if (selectedOptions.length > 0 && selectedCategoryOptions.length > 0) {
            trackPromise(GetProductDetails())
        }
    }, [selectedCategoryOptions, selectedOptions])

    useEffect(() => {
        setPage(0);
        if (selectedOptions.length == 0) {
            setProductcatogery([])
        } else {
            trackPromise(GetProductCategoties())
        }
    }, [selectedOptions])


    async function GetProductCategoties() {
        var res = await services.GetProductCategoties()
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productCategoryName, value: res[i].productCategoryID })
            }
            setProductcatogery(newOptionArray);
        }
    }

    async function GetProductDetails() {
        var res = await services.GetProductsByFactoryIDProductcatogeryID(
            selectedOptions.map(x => x).join(','),
            selectedCategoryOptions.map(x => x).join(",")
        )
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productName, value: res[i].productID })
            }
            setProduct(newOptionArray);
        }
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    function getSelectedDropdownValuesForReport() {
        var grpname
        {
            group.map((x) => (
                x.groupID == formik.values.groupID ? grpname = x.groupName : null
            ))
        }
        var operationentityname
        {
            factory.map((x) => (
                x.factoryID == formik.values.operationEntityID ? operationentityname = x.factoryName : null
            ))
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetVCCFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
            }
            setFactory(newOptionArray);
        }
    }

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'Date Range':
                        x.weekStartDate && x.weekEndDate && new Date(x.weekStartDate).getFullYear() > 1900
                            ? `${new Date(x.weekStartDate).toLocaleDateString('en-CA')}  -  ${new Date(x.weekEndDate).toLocaleDateString('en-CA')}`
                            : x.orderDate
                                ? new Date(x.orderDate).toLocaleDateString('en-CA')
                                : '-',
                    'factoryName': x.factoryName,
                    'SKU Code': x.skuCode,
                    'SKU Description': x.skuDescription,
                    'Annual Target Plan | Demand Forecasting':
                        x.demandForecasting == null || x.demandForecasting === 0
                            ? '–'
                            : parseFloat(x.demandForecasting).toFixed(2),
                    'Cultivated Quantity': x.cultivatedQty == 0 ? '-' : parseFloat(x.cultivatedQty).toFixed(2),
                    'Supplied Quantity': x.netAmount == 0 ? '-' : parseFloat(x.netAmount).toFixed(2)
                }
                res.push(vr);
            });
            var vr = {
                'Date': 'Total',
                'Annual Target Plan | Demand Forecasting': totalValues.totalDemand == 0 ? '–' : parseFloat(totalValues.totalDemand).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'Cultivated Quantity': totalValues.totalCultivate == 0 ? '-' : parseFloat(totalValues.totalCultivate).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                'Supplied Quantity': totalValues.totalSupply == 0 ? '-' : parseFloat(totalValues.totalSupply).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            }
            res.push(vr);
        }
        return res;
    }

    async function createFile(array) {
        var file = await createDataForExcel(reportData);

        var settings = {
            sheetName: 'Cultivation Efficiency Against Target Annual Plan for FCC Report',
            fileName: 'Cultivation Efficiency Against Target Annual Plan for FCC Report',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'AnnualPlanForFCCReport',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    const handleSelectChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedOptions(selectedOptions.length === factory.length ? [] : factory.map((option) => option.value));
        } else {
            setSelectedOptions(value);
        }
    };

    const handleSelectCategoryChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedCategoryOptions(selectedCategoryOptions.length === productcatogery.length ? [] : productcatogery.map((option) => option.value));
        } else {
            setSelectedCategoryOptions(value);
        }
    };

    const handleSelectProductChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedProductOptions(selectedProductOptions.length === product.length ? [] : product.map((option) => option.value));
        } else {
            setSelectedProductOptions(value);
        }
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    };

    const handleClearCategorySelection = () => {
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    };

    const handleClearProductSelection = () => {
        setSelectedProductOptions([]);
    };

    function getSelectedDropdownValuesForReport() {
        const facName = [];
        selectedOptions.forEach(x => {
            const fildered = (factory.find(y => x == y.value)) == undefined ? '' : factory.find(y => x == y.value).label
            facName.push(fildered)
        });

        const categoryName = [];
        selectedCategoryOptions.forEach(x => {
            const filterCategory = productcatogery.find(y => x == y.value).label
            categoryName.push(filterCategory);
        })

        const productName = [];
        selectedProductOptions.forEach(x => {
            const filterProduct = product.find(y => x == y.value).label
            productName.push(filterProduct);
        })

        let groups = group.find(x => x.groupID == formik.values.groupID)

        setSelectedSearchValues({
            ...selectedSearchValues,
            groupID: groups.groupName,
            operationEntityID: facName.length == 0 ? 'All Fresh Collection Centers' : facName.filter(x => x !== '').join(','),
            productCategoryID: categoryName.map(x => x).join(','),
            productID: productName.map(x => x).join(',')
        });
    }

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = factory.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderCategorySelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = productcatogery.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderProductSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = product.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = product.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = product.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    return (
        <>
            <LoadingComponent />
            <Page title="Cultivation Efficiency Against Target Annual Plan for FCC |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/AnnualPlanForFCC"}
                        btname="Add"
                        pageName="Cultivation Efficiency Against Target Annual Plan for FCC Report"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            style: {
                                                height: "48px",
                                                width: "100%"
                                            },
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                        <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptions}
                                            onChange={handleSelectChange}
                                            label="Fresh Collection Center "
                                            disabled={!permissionList.isFactoryFilterEnabled}
                                            renderValue={(selected) => renderSelectedValue(selected)}
                                            InputProps={{
                                                style: {
                                                    height: "48px",
                                                    width: "100%"
                                                },
                                            }}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedOptions.length === factory.length} color="primary" />
                                                All Fresh Collection Center
                                            </MenuItem>
                                            {factory.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.operationEntityID && errors.operationEntityID && (
                                            <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                        )}
                                        {selectedOptions.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                {!permissionList.isFactoryFilterEnabled ? null :
                                                    <ClearIcon />}
                                            </IconButton>
                                        )}
                                    </FormControl>
                                    <FormControl fullWidth error={Boolean(touched.productCategoryID && errors.productCategoryID)}>
                                        <InputLabel id="multi-select-label">Product Category * </InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedCategoryOptions}
                                            onChange={handleSelectCategoryChange}
                                            label="Product Category "
                                            disabled={selectedOptions.length == 0}
                                            renderValue={(selected) => renderCategorySelectedValue(selected)}
                                            InputProps={{
                                                style: {
                                                    height: "48px",
                                                    width: "100%"
                                                },
                                            }}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedCategoryOptions.length === productcatogery.length} color="primary" />
                                                All Product Category
                                            </MenuItem>
                                            {productcatogery.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedCategoryOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.productCategoryID && errors.productCategoryID && (
                                            <FormHelperText>{errors.productCategoryID}</FormHelperText>
                                        )}
                                        {selectedCategoryOptions.length > 0 && (
                                            <IconButton onClick={handleClearCategorySelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <FormControl fullWidth error={Boolean(touched.productID && errors.productID)}>
                                        <InputLabel id="multi-select-label">Product * </InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedProductOptions}
                                            onChange={handleSelectProductChange}
                                            label="Product"
                                            disabled={selectedCategoryOptions.length == 0}
                                            renderValue={(selected) => renderProductSelectedValue(selected)}
                                            InputProps={{
                                                style: {
                                                    height: "48px",
                                                    width: "100%"
                                                },
                                            }}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedProductOptions.length === product.length} color="primary" />
                                                All Products
                                            </MenuItem>
                                            {product.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedProductOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.productID && errors.productID && (
                                            <FormHelperText>{errors.productID}</FormHelperText>
                                        )}
                                        {selectedProductOptions.length > 0 && (
                                            <IconButton onClick={handleClearProductSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="From Date *"
                                            value={fromDate}
                                            onChange={(newValue) => {
                                                if (newValue && fromDate && newValue.toDateString() === fromDate.toDateString()) {
                                                    return;
                                                }
                                                if (newValue) {
                                                    setFromDate(newValue);
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        fromDate: newValue.toISOString()
                                                    }));
                                                }
                                            }}
                                            shouldDisableDate={(date) => {
                                                return date.getDay() !== 1;
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...getFieldProps('fromDate')}
                                                    onKeyDown={onKeyDown}
                                                    onClick={e => e.preventDefault()}
                                                    error={Boolean(touched.fromDate && errors.fromDate)}
                                                    helperText={touched.fromDate && errors.fromDate}
                                                    {...params}
                                                    inputProps={{
                                                        ...params.inputProps,
                                                        readOnly: true,
                                                    }}
                                                />
                                            )}
                                            InputProps={{
                                                readOnly: true,
                                                style: {
                                                    height: "48px",
                                                    width: "100%"
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="To Date *"
                                            value={toDate}
                                            onChange={(newValue) => {
                                                if (
                                                    !newValue || (toDate && newValue.toDateString() === toDate.toDateString())
                                                ) {
                                                    return;
                                                }
                                                setToDate(newValue);
                                                setFormData(prev => ({
                                                    ...prev,
                                                    toDate: newValue ? newValue.toISOString() : null
                                                }));
                                            }}
                                            minDate={fromDate}
                                            shouldDisableDate={(date) => {
                                                if (!fromDate) return true;
                                                return date.getDay() !== 0;
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...getFieldProps('toDate')}
                                                    onKeyDown={onKeyDown}
                                                    error={Boolean(touched.toDate && errors.toDate)}
                                                    helperText={touched.toDate && errors.toDate}
                                                    {...params}
                                                />
                                            )}
                                            InputProps={{
                                                style: {
                                                    height: "48px",
                                                    width: "100%"
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                </Stack>
                                <br />
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                    <Button
                                        type="button"
                                        variant="outlined"
                                        color='error'
                                        onClick={() => clearAll()}
                                    > Clear</Button>
                                    <Button
                                        type="submit"
                                        color='secondary'
                                        variant="outlined"
                                    >Search</Button>
                                </Stack>
                            </Stack>
                            <br />
                            <>
                                {reportData.length === 0 ? null :
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <Box display="flex" justifyContent="flex-end" flexDirection="column" >
                                                    <TableContainer component={Paper} style={{ maxHeight: '500px', overflow: 'auto' }}>
                                                        <Table className={classes.table} able size="small" aria-label="sticky table" Table stickyHeader>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>Date Range </TableCell>
                                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>Collection Center</TableCell>
                                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>SKU Code</TableCell>
                                                                    <TableCell align="left" style={{ fontWeight: "bold" }}>SKU Description</TableCell>
                                                                    <TableCell align="right" style={{ fontWeight: "bold" }}>Annual Target Plan | Demand Forecasting</TableCell>
                                                                    <TableCell align="right" style={{ fontWeight: "bold" }}>Cultivated Quantity</TableCell>
                                                                    <TableCell align="right" style={{ fontWeight: "bold" }}>Supplied Quantity</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {(() => {
                                                                    const grouped = {};
                                                                    reportData.forEach((row) => {
                                                                        const key = `${row.weekStartDate}-${row.weekEndDate}-${row.skuCode}-${row.skuDescription}-${row.demandForecasting}`;
                                                                        if (!grouped[key]) grouped[key] = [];
                                                                        grouped[key].push(row);
                                                                    });

                                                                    const allRows = [];
                                                                    Object.entries(grouped).forEach(([key, group]) => {
                                                                        group.forEach((row, index) => {
                                                                            allRows.push({ key, row, index, groupLength: group.length });
                                                                        });
                                                                    });

                                                                    const startIndex = page * limit;
                                                                    const endIndex = startIndex + limit;
                                                                    const paginatedRows = allRows.slice(startIndex, endIndex);

                                                                    return paginatedRows.map(({ key, row, index, groupLength }) => (
                                                                        <TableRow key={`${key}-${index}`}>
                                                                            <TableCell align="left" style={{ whiteSpace: 'nowrap' }}>
                                                                                {row.weekStartDate && row.weekEndDate && new Date(row.weekStartDate).getFullYear() > 1900
                                                                                    ? `${new Date(row.weekStartDate).toLocaleDateString('en-US', {
                                                                                        year: 'numeric',
                                                                                        month: '2-digit',
                                                                                        day: '2-digit',
                                                                                    })} - ${new Date(row.weekEndDate).toLocaleDateString('en-US', {
                                                                                        year: 'numeric',
                                                                                        month: '2-digit',
                                                                                        day: '2-digit',
                                                                                    })}`
                                                                                    : '-'}
                                                                            </TableCell>
                                                                            <TableCell align="left">{row.factoryName}</TableCell>
                                                                            <TableCell align="left">{row.skuCode}</TableCell>
                                                                            <TableCell align="left">{row.skuDescription}</TableCell>
                                                                            {index === 0 && (
                                                                                <TableCell
                                                                                    align="right"
                                                                                    rowSpan={groupLength}
                                                                                    style={{
                                                                                        verticalAlign: 'middle',
                                                                                    }}
                                                                                >
                                                                                    {row.demandForecasting == null || row.demandForecasting === 0
                                                                                        ? '–'
                                                                                        : parseFloat(row.demandForecasting).toLocaleString('en-US', {
                                                                                            minimumFractionDigits: 2,
                                                                                            maximumFractionDigits: 2,
                                                                                        })}
                                                                                </TableCell>
                                                                            )}
                                                                            <TableCell align="right">
                                                                                {row.cultivatedQty == 0
                                                                                    ? '-'
                                                                                    : parseFloat(row.cultivatedQty).toLocaleString('en-US', {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2,
                                                                                    })}
                                                                            </TableCell>
                                                                            <TableCell align="right">
                                                                                {row.netAmount == 0
                                                                                    ? '-'
                                                                                    : parseFloat(row.netAmount).toLocaleString('en-US', {
                                                                                        minimumFractionDigits: 2,
                                                                                        maximumFractionDigits: 2,
                                                                                    })}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ));
                                                                })()}
                                                            </TableBody>
                                                            <TableRow>
                                                                <TableCell colSpan={4} align={'left'} style={{ fontWeight: 'bold' }}>Total</TableCell>
                                                                <TableCell align={'right'} style={{ fontWeight: 'bold' }}>
                                                                    {totalValues.totalDemand == 0 ? '–' : parseFloat(totalValues.totalDemand).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </TableCell>
                                                                <TableCell align={'right'} style={{ fontWeight: 'bold' }}>
                                                                    {totalValues.totalCultivate == 0 ? '-' : parseFloat(totalValues.totalCultivate).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </TableCell>
                                                                <TableCell align={'right'} style={{ fontWeight: 'bold' }}>
                                                                    {totalValues.totalSupply == 0 ? '-' : parseFloat(totalValues.totalSupply).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                </TableCell>
                                                            </TableRow>
                                                        </Table>
                                                        <TablePagination
                                                            rowsPerPageOptions={[5, 10, 25]}
                                                            component="div"
                                                            count={reportData.length}
                                                            rowsPerPage={limit}
                                                            page={page}
                                                            onPageChange={handleChangePage}
                                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                                        />
                                                    </TableContainer>
                                                </Box>
                                            </div>
                                        </div>
                                        <div className="card-footer" style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                        }}>

                                        </div>
                                    </div>
                                }
                            </>
                        </Form>
                    </FormikProvider>
                    {reportData.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <div>&nbsp;</div>
                            <style>
                                {`
                                 @page  {
                                            size: A4 landscape; 
                                            margin: 20mm;
                                        }
                               `}
                            </style>
                            <ReactToPrint
                                documentTitle={"Cultivation Efciency Against Target Annual Plan for FCC Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    reportData={reportData}
                                    totalValues={totalValues}
                                />
                            </div>
                        </Box> : null
                    }
                </Container>
            </Page>
        </>
    );
}

